import { createReducer, on } from '@ngrx/store';
import { SteelType } from '@shared/models';
import * as CarbonImpactActions from '@state/actions/carbon-impact.actions';

export const carbonImpactFeatureKey = 'carbonImpact';

export interface State {
  capacityOfFarm: number;
  compositeCapacity: number;
  selectedSteelType: SteelType;
}

export const initialState: State = {
  capacityOfFarm: 100,
  compositeCapacity: 30,
  selectedSteelType: 'Virgin',
};

export const reducer = createReducer(
  initialState,
  on(CarbonImpactActions.SubmitCapacityOfFarm, (state, { capacityOfFarm }) => {
    return {
      ...state,
      capacityOfFarm,
    };
  }),
  on(
    CarbonImpactActions.SubmitCompositeCapacity,
    (state, { compositeCapacity }) => {
      return {
        ...state,
        compositeCapacity,
      };
    }
  ),
  on(CarbonImpactActions.ResetIndirectImpacts, (state) => {
    return {
      ...state,
      capacityOfFarm: initialState.capacityOfFarm,
      compositeCapacity: initialState.compositeCapacity,
    };
  }),
  on(
    CarbonImpactActions.UpdateSelectedSteelType,
    (state, { selectedSteelType }) => {
      return {
        ...state,
        selectedSteelType,
      };
    }
  )
);

/**
 * Because the data structure is defined within the reducer it is optimal to
 * locate our selector functions at this level. If store is to be thought of
 * as a database, and reducers the tables, selectors can be considered the
 * queries into said database. Remember to keep your selectors small and
 * focused so they can be combined and composed to fit each particular
 * use-case.
 */

export const selectCapacityOfFarm = (state: State) => state.capacityOfFarm;
export const selectCompositeCapacity = (state: State) =>
  state.compositeCapacity;
export const selectSteelType = (state: State) => state.selectedSteelType;
